<script>
  // Reject dialog shared by the submissions list and the moderation feed.
  //
  //   <RejectModal bind:open questPrompt={target?.quest?.prompt} categories={rejection_categories}
  //     onconfirm={({ rejection_category, rejection_reason }) => …} />
  //
  // The caller closes it (open = false) once its request settles.
  import Modal from '../modal.svelte'
  import { Button, Combobox } from '../ui'

  let { open = $bindable(false), questPrompt = null, categories = [], onconfirm = () => {} } = $props()

  let category = $state('')
  let reason = $state('')

  $effect(() => {
    if (!open) return
    category = ''
    reason = ''
  })

  const confirm = () => onconfirm({ rejection_category: category, rejection_reason: reason })
</script>

<Modal bind:open title="Reject submission" onclose={() => (open = false)}>
  {#if open}
    <p class="text-sm text-base-content/60 mb-4">
      The user's moment is locked to private — only they can still see it — and the quest returns to Ready. They can
      re-submit while the quest is active. Category and reason are optional and shown to the user.
      {#if questPrompt}<span class="block mt-1">Quest: {questPrompt}</span>{/if}
    </p>

    <fieldset class="fieldset">
      <legend class="fieldset-legend">Category (optional)</legend>
      <Combobox bind:value={category} options={categories} clearable placeholder="No category" ariaLabel="Rejection category" />
    </fieldset>

    <fieldset class="fieldset">
      <legend class="fieldset-legend">Reason (optional)</legend>
      <textarea class="textarea w-full" rows="3" placeholder="Feedback shown to the user…" bind:value={reason}></textarea>
    </fieldset>

    <div class="flex justify-end gap-2 mt-4">
      <Button variant="ghost" onclick={() => (open = false)}>Cancel</Button>
      <Button variant="error" onclick={confirm}>Reject</Button>
    </div>
  {/if}
</Modal>
